<div class="container-fluid vh-100 d-flex p-3 p-lg-4">
  <div class="row">
    <div class="col-lg-6 h-lg-100 px-lg-3">
      <img
        src="images/login-banner.png"
        class="img-fluid h-100 rounded-3 rounded-lg-5 flip-x"
        style="object-fit: cover"
      />
    </div>

    <div class="col-lg-6 d-flex flex-column">
      <div class="mt-3 mt-lg-0 mb-3 mb-lg-5">
        <button
          class="btn btn-lang-toggle d-flex align-items-center gap-2"
          (click)="languageService.toggleLang()"
        >
          <img
            *ngIf="languageService.currentLang === 'en'"
            src="icons/uae-flag.svg"
            alt="UAE"
            width="16"
            height="16"
          />
          <img
            *ngIf="languageService.currentLang === 'ar'"
            src="icons/uk-flag.svg"
            alt="EN"
            class="icon-svg"
            width="16"
            height="16"
          />
          <span>
            {{ languageService.currentLang === "en" ? "AR" : "EN" }}
          </span>
        </button>
      </div>
      <div class="w-100 w-lg-50 w-md-75 align-self-center mt-lg-5">
        <div
          class="mb-4 d-flex flex-column align-items-center align-items-lg-start"
        >
          <img
            src="logos/logo-charity.svg"
            alt="logo"
            class="w-55 m-autoimg-fluid"
          />
          <h2 class="mt-3 fw-extrabold">
            {{ "features.login.title" | translate }}
            <span class="emoji-large">👋</span>
          </h2>
        </div>

        <form
          [formGroup]="loginForm"
          (ngSubmit)="onLogin()"
          novalidate
          class="d-flex flex-column gap-3 gap-lg-4"
        >
          <div class="d-flex flex-column gap-2">
            <label>{{ "features.login.username" | translate }}</label>
            <div>
              <input
                class="form-control"
                formControlName="username"
                [placeholder]="'features.login.enterUsername' | translate"
                [class.is-invalid]="hasError('username')"
              />
              <div
                class="invalid-feedback"
                *ngIf="hasError('username', 'required')"
              >
                {{ "validation.required" | translate }}
              </div>
            </div>
            <div
              class="invalid-feedback"
              *ngIf="hasError('username', 'emailOrUsername')"
            >
              {{ "validation.emailOrUsername" | translate }}
            </div>
          </div>

          <!-- Password -->
          <div class="d-flex flex-column gap-2">
            <label>{{ "features.login.password" | translate }}</label>
            <div class="position-relative mb-3">
              <input
                class="form-control"
                [ngClass]="{
                  'pe-5': languageService.currentLang !== 'ar',
                  'ps-5': languageService.currentLang === 'ar'
                }"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                [placeholder]="'features.login.enterPassword' | translate"
                [class.is-invalid]="hasError('password')"
              />

              <img
                (click)="togglePassword()"
                [src]="
                  showPassword ? 'icons/eye-slash.svg' : 'icons/eye-icon.svg'
                "
                alt="toggle password"
                class="position-absolute"
                [style.top.%]="50"
                [style.transform]="'translateY(-50%)'"
                [style.cursor]="'pointer'"
                [style.width.px]="16"
                [style.height.px]="16"
                [style.left.px]="
                  languageService.currentLang === 'ar' ? 12 : null
                "
                [style.right.px]="
                  languageService.currentLang === 'ar' ? null : 12
                "
                style="z-index: 2"
              />

              <div
                class="invalid-feedback"
                *ngIf="hasError('password')"
                style="position: absolute; top: 100%"
              >
                <ng-container
                  *ngIf="hasError('password', 'required'); else checkMinLength"
                >
                  {{ "validation.required" | translate }}
                </ng-container>

                <ng-template #checkMinLength>
                  <ng-container
                    *ngIf="hasError('password', 'minlength'); else checkPattern"
                  >
                    {{ "validation.minLength" | translate : { min: 8 } }}
                  </ng-container>
                </ng-template>

                <ng-template #checkPattern>
                  <ng-container *ngIf="hasError('password', 'pattern')">
                    {{ "validation.passwordComplexity" | translate }}
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </div>

          <button
            type="submit"
            [disabled]="isSubmitting"
            class="btn btn-primary w-100 mt-3"
          >
            {{ "features.login.loginButton" | translate }}
          </button>
        </form>
      </div>
      <p class="text-center mt-4 mt-lg-auto text-muted">
        {{ "features.login.copyright" | translate : { year: currentYear } }}
      </p>
    </div>
  </div>
</div>
<app-loading
  *ngIf="loading$ | async"
  [message]="'loadingMessage' | translate"
></app-loading>
